export class ExportResult {
  CompanyId?: number;
  FromDate: any;
  ToDate: any;

  constructor(companyId: number, fromDate: any, toDate: any) {
    this.CompanyId = companyId;
    this.FromDate = fromDate;
    this.ToDate = toDate;
  }
}